// @flow
export const ATWORK: 'atwork' = 'atwork';
export const OFFICE: 'office' = 'office';
